import { supabase } from './supabase'

export async function uploadFile(bucket: string, path: string, file: File, opts?: { upsert?: boolean }) {
  const { error } = await supabase.storage
    .from(bucket)
    .upload(path, file, { upsert: opts?.upsert ?? false, contentType: file.type })
  if (error) throw error
  return path
}

export async function deleteFile(bucket: string, path: string) {
  const { error } = await supabase.storage.from(bucket).remove([path])
  if (error) throw error
}

export async function getSignedUrl(bucket: string, path: string, expiresIn = 3600) {
  const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, expiresIn)
  if (error) throw error
  return data.signedUrl
}
